<script lang="ts" setup>
import VCollapsibleSection from '@shared/component/VCollapsibleSection/VCollapsibleSection.vue';
import VSearch from '@shared/component/VSearch/VSearch.vue';
import { computed, ref } from 'vue';

import { faqItems } from '../faq-data';

const zoekterm = ref('');
const openItem = ref<string | null>(null);

const gefilterdeItems = computed(() => {
  if (zoekterm.value.length < 3) return faqItems;

  const term = zoekterm.value.toLowerCase();
  return faqItems.filter(
    (item) =>
      item.vraag.toLowerCase().includes(term) ||
      item.keywords.some((kw) => kw.toLowerCase().includes(term)),
  );
});

function isOpen(vraag: string) {
  return openItem.value === vraag;
}

function toggleItem(vraag: string, open: boolean) {
  openItem.value = open ? vraag : null;
}
</script>

<template>
  <div>
    <VSearch v-model="zoekterm" placeholder="Zoeken..." class="mb-4 w-full max-w-xs" />

    <div class="rounded-lg bg-white p-4 shadow-sm">
      <div v-if="gefilterdeItems.length === 0" class="text-grey-500">
        Geen vragen gevonden voor "{{ zoekterm }}".
      </div>

      <VCollapsibleSection
        v-for="item in gefilterdeItems"
        :key="item.vraag"
        :open="isOpen(item.vraag)"
        padding="sm"
        @update:open="(open) => toggleItem(item.vraag, open)"
      >
        <template #title>
          <span class="font-medium text-primary">{{ item.vraag }}</span>
        </template>
        <template #content>
          <div class="faq-antwoord text-sm text-grey-700" v-sanitized-html="item.antwoord"></div>
        </template>
      </VCollapsibleSection>
    </div>
  </div>
</template>

<style>
.faq-antwoord ol,
.faq-antwoord ul {
  @apply my-3 ml-6;
}

.faq-antwoord ol {
  @apply list-decimal;
}

.faq-antwoord ul {
  @apply list-disc;
}

.faq-antwoord li {
  @apply my-1;
}

.faq-antwoord p {
  @apply my-2;
}
</style>
